import { render, staticRenderFns } from "./HeadedSlider.vue?vue&type=template&id=b9705be4"
import script from "./HeadedSlider.vue?vue&type=script&lang=js"
export * from "./HeadedSlider.vue?vue&type=script&lang=js"
import style0 from "./HeadedSlider.vue?vue&type=style&index=0&id=b9705be4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports